import { render, staticRenderFns } from "./VendorShipList.vue?vue&type=template&id=3936c622&scoped=true"
import script from "./VendorShipList.vue?vue&type=script&lang=js"
export * from "./VendorShipList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3936c622",
  null
  
)

export default component.exports